import React from "react";
import { FormControl, Select, MenuItem, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import icon from "../../../../../../../common/components/icon-component/icon";
import { PACKAGE_ICONS } from "./constants";
import styles from "./IconPicker.module.css";

export default function IconPicker({ value, onChange, label, size = "small" }) {
	const renderValue = (selected) => {
		if (!selected) {
			return <span className={styles.placeholder}>{label}</span>;
		}
		const faIcon = icon[selected];
		return faIcon ? (
			<Box className={styles.selectedIcon}>
				<FontAwesomeIcon icon={faIcon} />
			</Box>
		) : (
			selected
		);
	};

	return (
		<FormControl fullWidth className={styles.formControl} variant="outlined">
			<Select
				displayEmpty
				className={styles.select}
				MenuProps={{
					PaperProps: {
						className: styles.emojiPickerMenu,
					},
					MenuListProps: {
						className: styles.emojiMenuList,
					},
				}}
				renderValue={renderValue}
				size={size}
				value={value || ""}
				onChange={onChange}
			>
				<MenuItem className={styles.emojiMenuItemPlaceholder} value="">
					<em>{label}</em>
				</MenuItem>
				{PACKAGE_ICONS.map((iconName) => {
					const faIcon = icon[iconName];
					return faIcon ? (
						<MenuItem key={iconName} className={styles.emojiMenuItem} value={iconName}>
							<Box className={styles.emojiIcon}>
								<FontAwesomeIcon icon={faIcon} />
							</Box>
						</MenuItem>
					) : null;
				})}
			</Select>
		</FormControl>
	);
}
